import { render, staticRenderFns } from "./HoverableSidenav.vue?vue&type=template&id=6c9e89c2&lang=html&"
import script from "./HoverableSidenav.vue?vue&type=script&lang=js&"
export * from "./HoverableSidenav.vue?vue&type=script&lang=js&"
import style0 from "./HoverableSidenav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports